import React from "react";
import { useNavigate } from "react-router-dom";

const ContentHeader = () => {
  const navigate = useNavigate();
  return (
    <header className="content-header" data-testid="content-header">
      <div className="content-header-inner">
        <button className="content-logo" onClick={() => navigate("/")} data-testid="content-logo">
          Mortgage Survival Playbook <em>2026</em>
        </button>
        <div className="content-nav-links">
          <button className="content-nav-link" onClick={() => navigate("/")} data-testid="nav-home">Home</button>
          <button className="content-nav-link" onClick={() => navigate("/insights")} data-testid="nav-insights">Insights</button>
          <button className="content-nav-link" onClick={() => navigate("/about")} data-testid="nav-about">About</button>
          <button className="content-nav-cta" onClick={() => navigate("/#purchase")} data-testid="nav-acquire">Acquire License</button>
        </div>
      </div>
    </header>
  );
};

export default ContentHeader;
